module.exports = __webpack_public_path__ + "static/media/anfcc.06365cf6.png";